import { useEffect, useState } from "react";
import { getStorage, getDownloadURL, ref as imageRef } from "firebase/storage";
import parcelImage from "../../assets/parcel.svg"

const BundleParcelImageComponents = ({ path }) => {
    const [url, setUrl] = useState(null);

    useEffect(() => {
        if (!path) return;

        const storage = getStorage();
        const imgRef = imageRef(storage, path);

        getDownloadURL(imgRef)
            .then(setUrl)
            .catch(() => setUrl(null));
    }, [path]);

    return (
        <img
            src={url || parcelImage}
            alt="parcel"
            style={{ width: 35, height: 35 }}
        />
    );
};

export default BundleParcelImageComponents;
